import axiosInstance from "./axiosInstance";
import { Mumeen } from "../types/itsDetails";

export interface VenueApi {
  venueId: number;
  venueName: string;
  contactNo: string;
  emailAddress: string;
  description: string;
  timeZone: string;
  isActive: boolean;
}

export interface CreateReceiptDetail {
  unitRate: number;
  units: number;
  roundoff: number;
  isUnitRate: boolean;
  currencyHeadMasterId: number;
  discount: number;
}

export interface CreateReceiptPayload {
  publicId?: string;
  isEmailSent?: boolean;
  receiptNo?: string;
  itsNo: string;
  fullName: string;
  phoneNumber: string;
  email: string;
  watan: string;
  venueId: number;
  currencyId: number;
  totalAmount: number;
  isApproved: boolean;
  details: CreateReceiptDetail[];
  createdByUserID: number;
  blodUrl: string;
}

export interface ReceiptFilters {
  locationCode?: string;
  headId?: number;
  currencyCode?: string;
  userId?: string | number;
  isApproved?: boolean;
  fromDate?: string;
  toDate?: string;
  pageNo?: string | number;
  pageNumber?: number;
  pageSize?: number;
}

export interface ReceiptResponse {
  receiptNo: string;
  bolbUrl?: string;
  publicId?:string
}

export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getVenues = async (): Promise<VenueApi[]> => {
  const res = await axiosInstance.get("/Venues?onlyActive=true", {
    headers: getAuthHeader(),
  });
  return res.data;
};

export const getDetailsByITS = async (
  itsNo: string,
  force: true,
): Promise<Mumeen | null> => {
  try {
    const response = await axiosInstance.get(`/its/${itsNo}?force=${force}`, {
      headers: {
        ...getAuthHeader(),
      },
    });
    return response.data;
  } catch (error) {
    return null;
  }
};

export const createReceipts = async (
  payload: CreateReceiptPayload,
): Promise<ReceiptResponse> => {
  try {
    const response = await axiosInstance.post("/receipts", payload, {
      headers: {
        ...getAuthHeader(),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// MANNAT NIYAZ DASHBOARD API
export const getMiqaatNiyazDashboardList = async (
  filters: ReceiptFilters = {},
) => {
  try {
    const response = await axiosInstance.get("/Receipts/list", {
      params: {
        UserId: filters.userId ?? 0,
        // pageNo: filters.pageNo ?? 0,
        // pageSize: filters.pageSize ?? 20,
        LocationCode: filters.locationCode,
        HeadId: filters.headId,
        CurrencyCode: filters.currencyCode,
        IsApproved: filters.isApproved,
        FromDate: filters.fromDate,
        ToDate: filters.toDate,
      },
      headers: {
        ...getAuthHeader(),
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const approveReceipts = async (
  payload: {
    receiptIds: number[];
    approvedByUserId: number;
  },
) => {
  try {
    const response = await axiosInstance.post(
      `/Receipts/approve`,
      payload,
      {
        headers: {
          ...getAuthHeader(),
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getReceiptsDetails = async (receiptId: string) => {
  try {
    const response = await axiosInstance.get(`/Receipts/${receiptId}/print`, {
      headers: {
        ...getAuthHeader(),
      },
    });
    return response.data;
  } catch (error) {
    return null;
  }
};

// GET USERS WITH PAGINATION
export const getMiqaatUsers = async () => {
  const res = await axiosInstance.get("/User/users", {
    headers: getAuthHeader(),
  });

  return res.data;
};

export const getReceiptPdf = async (publicId: string, download: boolean) => {
  return axiosInstance.get(`/Receipts/${publicId}/pdf`, {
    params: {
      download,
    },
    responseType: "blob",
    headers: {
      ...getAuthHeader(),
    },
  });
};


export const SendReceiptEmail = async (
  publicId: string,
) => {
  try {
    const response = await axiosInstance.post(
      `/Receipts/${publicId}/send-email`,
      {
        publicId:publicId
      },
      {
        headers: {
          ...getAuthHeader(),
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

// MANNAT NIYAZ DASHBOARD API
